import ENDPOINTS from "../ApiManager/DescargaEndPoints";
import environment from "../environments/environment";

const BASE_URL = environment.api_url;

class DescargaService {
	
	static getDescargaFichero = () => {
		const url = BASE_URL + ENDPOINTS.GET_DESCARGA();
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
          		'Content-Type': 'application/octet-stream',
			}
		});
	};
	
}

export default DescargaService;